import { Controller } from 'stimulus';
import Swiper, { Navigation } from 'swiper';

class ReviewsSlider extends Controller {
  connect() {
    Swiper.use([Navigation]);

    this.swiper = new Swiper(this.element, {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      navigation: {
        prevEl: '.reviews__slider-prev',
        nextEl: '.reviews__slider-next',
      },
    });
  }
}

export default ReviewsSlider;
